import { apiClient, fastApiClient } from "../App";

// Dashboard Overview
export const getDashboardOverview = async () => {
  const response = await fastApiClient.get("/dashboard/overview");
  return response.data;
};

// Campaign List
export const getCampaigns = async () => {
  const response = await fastApiClient.get("/campaigns");
  return response.data?.campaigns || [];
};


// Campaign Trends
export const getCampaignTrends = async (days = 7) => {
  const response = await fastApiClient.get(
    `/dashboard/campaign-trends?days=${days}`
  );
  return response.data;
};

// Twilio Metrics
export const getTwilioMetrics = async () => {
  const response = await fastApiClient.get("/dashboard/twilio-metrics");
  return response.data;
};